import * as Actions from "../constant/ActionTypes";
import * as api from '../../api';

// Add a user entry
export const listDevicesPerSite = (hwid) => async (dispatch) => {
    try {
        const { data } = await api.listDevicesPerSite(hwid);

        dispatch({
            type: Actions.LIST_DEVICES_PER_SITE,
            payload: data
        })
    } catch (error) {
        console.log(error);
    }
}